<template>
  <div class="loading-box">
    <div class="spinner-box">
      <div class="text">Loading...</div>
      <div class="circle-border">
        <div class="circle-core"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data () {
    return {}
  },
  created () {},
  mounted () {},
  beforeDestroy () {},
  computed: {},
  watch: {},
  methods: {}
}
</script>

<style lang="scss" scoped>
@keyframes spin {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(359deg);
  }
}
.loading-box {
  width: 100%;
  .spinner-box {
    // width: 300px;
    // height: 300px;
    margin: 20% auto;
    display: flex;
    justify-content: center;
    background-color: transparent;
    position: relative;
    align-items: center;
    .text {
      color: $main0;
      font-size: 1.5rem;
      position: absolute;
      left: 0;
      right: 0;
      margin: 0 auto;
      z-index: 1;
      width: fit-content;
    }
    .circle-border {
      width: 150px;
      height: 150px;
      padding: 3px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      background: $main0;
      background: linear-gradient(
        0deg,
        rgba(63, 249, 220, 0.1) 33%,
        $main0 100%
      );
      animation: spin 0.8s linear 0s infinite;
      .circle-core {
        width: 100%;
        height: 100%;
        background-color: #fff;
        border-radius: 50%;
      }
    }
  }
  @media screen and (max-width: 767px) {
    .spinner-box {
      // width: 150px;
      // height: 150px;
      .text {
        font-size: 0.75rem;
      }
      .circle-border {
        width: 75px;
        height: 75px;
      }
    }
  }
}
</style>
